import React, { useState } from "react";

import {
  Checkbox,
  FormControl,
  ListItemIcon,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";

import mainStyles from "../../styles";

interface CheckboxFilterProps<ItemType extends string | number> {
  title: string;
  filterList: ItemType[];
  setFilterList: (newShown: ItemType[]) => void;
  allItems: ItemType[];
  displayNamesMapping: Record<ItemType, string>;
  testId?: string;
  size?: "medium" | "small" | undefined;
  disabled?: boolean;
  selectAllTestId?: string;
}

const CheckboxFilter = <ItemType extends string | number>(
  props: CheckboxFilterProps<ItemType>
) => {
  const {
    title,
    filterList,
    setFilterList,
    allItems,
    displayNamesMapping,
    size,
    disabled,
  } = props;

  const [editingFilterList, setEditingFilterList] = useState(filterList);

  const classes = mainStyles();

  const handleChange = (e: SelectChangeEvent<ItemType[]>) => {
    const value = e.target.value as string[];
    if (value[value.length - 1] == "all") {
      setEditingFilterList(
        editingFilterList.length === allItems.length ? [] : allItems
      );
      return;
    }

    setEditingFilterList(value as ItemType[]);
  };

  return (
    <FormControl
      variant="outlined"
      size="small"
      sx={classes.formControl}
      disabled={disabled}
    >
      <Select
        labelId="select-activity-type-filter"
        multiple
        displayEmpty
        renderValue={() => <b>{title}</b>}
        value={editingFilterList}
        onChange={handleChange}
        onOpen={() => setEditingFilterList(filterList)}
        onClose={() => setFilterList(editingFilterList)}
        data-testid={props.testId}
      >
        <MenuItem value="all">
          <ListItemIcon>
            <Checkbox
              checked={editingFilterList.length === allItems.length}
              indeterminate={
                editingFilterList.length > 0 &&
                editingFilterList.length < allItems.length
              }
              sx={classes.secondaryText}
              size={size}
              data-testid={props.selectAllTestId}
            />
          </ListItemIcon>
          <b>Select All</b>
        </MenuItem>
        {allItems.map((item) => (
          <MenuItem key={item} value={item}>
            <ListItemIcon>
              <Checkbox
                checked={editingFilterList.indexOf(item) > -1}
                size={size}
              />
            </ListItemIcon>
            {displayNamesMapping[item]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
export default CheckboxFilter;
